/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

export const Container = styled.div`
  margin-top: ${gridSize() * 2}px;
`;
